import { Injectable } from '@angular/core';

import { combineLatest, Observable, timer } from 'rxjs';
import { distinctUntilChanged, publishReplay, refCount, switchMap } from 'rxjs/operators';

import { isEqual } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class ShApiCachingHelper {
    protected DEFAULT_CACHE_TTL = 1800000; // 30 minutes
    protected cacheTimer$: Observable<any>;

    constructor() {
        this.cacheTimer$ = timer(0, this.DEFAULT_CACHE_TTL);
    }

    // Retriggers API call when timer runs out
    public cachedApiCall(apiCall$: Observable<any>, manualRefresh$?: Observable<void>): Observable<any> {
        const trigger$: Observable<any> = manualRefresh$
            ? combineLatest([this.cacheTimer$, manualRefresh$])
            : this.cacheTimer$;
        const cachedApiCall = trigger$.pipe(
            switchMap(() => apiCall$),
            distinctUntilChanged(isEqual),
            publishReplay(1),
            refCount()
        );

        return cachedApiCall;
    }
}
